import {
  CommentQueryParams,
  CommentsResponse,
  EventsListResponse,
  MarketsQueryParams,
  PricesHistoryResponse,
  SportsFutureCategoriesResponse,
  SportsSidebarResponse,
} from '@/types';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const DEFAULT_FUTURES_PARAMS = {
  limit: 10,
  offset: 0,
  active: true,
  closed: false,
} as const;

export const DEFAULT_SPORTS_PARAMS = {
  limit: 20,
  offset: 0,
  active: true,
  closed: false,
} as const;

export const sportsApi = {
  getSportsSidebarData: async (): Promise<SportsSidebarResponse> => {
    const response = await axiosClient.get<SportsSidebarResponse>(
      API_ENDPOINTS.MARKETS_SPORTS_SIDEBAR,
    );
    return response.data;
  },

  getSportsFutures: async (params?: MarketsQueryParams): Promise<EventsListResponse> => {
    const response = await axiosClient.get<EventsListResponse>(API_ENDPOINTS.MARKETS_EVENTS_LIST, {
      params: {
        ...DEFAULT_FUTURES_PARAMS,
        ...params,
      },
    });
    return response.data;
  },

  getSportsFutureCategories: async (): Promise<SportsFutureCategoriesResponse> => {
    const response = await axiosClient.get<SportsFutureCategoriesResponse>(
      API_ENDPOINTS.MARKETS_SPORTS_FUTURE_CATEGORIES,
    );
    return response.data;
  },

  getSportsPricesHistory: async (params: {
    market: string;
    interval?: string;
    fidelity?: number;
  }): Promise<PricesHistoryResponse> => {
    const response = await axiosClient.get<PricesHistoryResponse>(
      API_ENDPOINTS.MARKETS_SPORTS_PRICES_HISTORY,
      {
        params: {
          market: params.market,
          // Resolution (minutes) and window are chosen per selected range by the
          // caller. Sports games only last a few hours, so the old hard-coded
          // interval:'max' + fidelity:60 returned hourly points whose newest
          // value advanced only once an hour — the chart looked frozen during a
          // live game. Defaults kept for any caller that doesn't specify.
          fidelity: params.fidelity ?? 60,
          interval: params.interval ?? 'max',
        },
      },
    );
    return response.data;
  },
  getCommentsPaginated: async (params: CommentQueryParams): Promise<CommentsResponse> => {
    const response = await axiosClient.get<CommentsResponse>(API_ENDPOINTS.MARKETS_COMMENTS, {
      params,
    });
    return response.data;
  },
};
